import styled, { css } from 'styled-components';
import { themeGet } from 'styled-system';
import Flex from '../Flex';
import Text from '../Text';
import colors from '../themes/colors';
import theme from '../themes/theme';

export const BUTTON_VARIATIONS = {
  LARGE: 'large',
  SMALL: 'small'
};

const LargeButtonCSS = () => {
  return css`
    width: 48px;
    height: 48px;
  `;
};

const SmallButtonCSS = () => {
  return css`
    width: 32px;
    height: 32px;
  `;
};

const GreenBgStylesCSS = ({ styleVariation }) => {
  if (!styleVariation) return;

  return css`
    background: ${theme.colors.preciousStoneBlue[20]};
    border-radius: 25px;

    div {
      font-size: 18px;
      line-height: 22px;
      color: ${theme.colors.nightSkyBlack[100]};
    }
    button {
      width: 48px;
      height: 48px;
      background: ${theme.colors.preciousStoneBlue[20]};
      :hover {
        background: ${theme.colors.preciousStoneBlue[20]};
      }
      svg {
        width: 30px;
        height: 30px;
        fill: ${theme.colors.preciousStoneBlue[100]};
      }

      ${theme.mediaQueries.md} {
        width: 40px;
        height: 40px;
        svg {
          width: 24px;
          height: 24px;
        }
      }
    }
  `;
};

export const CounterWrapper = styled(Flex)`
  align-items: center;
  justify-content: ${({ isNewWidgetStyleActive }) => (isNewWidgetStyleActive ? 'flex-end' : 'center')};
  ${GreenBgStylesCSS}
`;

export const StyledButton = styled.button`
  ${({ 'aria-disabled': disabled }) => {
    if (disabled)
      return css`
        opacity: 0.6;
        background-color: ${({ buttonDisabledBG }) => buttonDisabledBG};
      `;
  }}
  ${({ variation }) => {
    return variation === BUTTON_VARIATIONS.LARGE ? LargeButtonCSS() : SmallButtonCSS();
  }}

  border-radius: 50%;
  border: none;
  outline-color: ${colors.focusBlue};
  outline-offset: 4px;
  transition: background-color 0.2s;
  background-color: ${({ buttonBG }) => buttonBG};
  position: relative;

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &:active {
    ${({ 'aria-disabled': disabled }) => {
      if (disabled)
        return css`
          background-color: ${({ buttonDisabledBG }) => buttonDisabledBG};
        `;
      return css`
        background-color: ${colors.preciousStoneBlue[100]};

        #animation-circle {
          transform: scale(1);
          background-color: ${colors.deepLakeBlue[50]};
        }
      `;
    }}
  }

  ${theme.mediaQueries.md} {
    &:hover {
      cursor: pointer;
      background-color: ${colors.deepLakeBlue[100]};
    }
  }

  touch-action: manipulation;
`;

export const AnimationCircle = styled.div`
  ${({ variation }) => (variation === BUTTON_VARIATIONS.LARGE ? LargeButtonCSS() : SmallButtonCSS())}
  border-radius: 50%;
  background-color: ${colors.deepLakeBlue[100]};
  position: absolute;
  top: 0;
  left: 0;
  transform: scale(0);
  transition: transform 0.2s, background-color 0.2s;
`;

export const DisplayText = styled(Text)`
  display: flex;
  justify-content: center;
  font-size: ${({ variation, fontSize }) => {
    return fontSize
      ? themeGet('fontSizes.' + fontSize)
      : variation === BUTTON_VARIATIONS.LARGE
      ? themeGet('fontSizes.3')
      : themeGet('fontSizes.7');
  }}px;
  line-height: ${({ lineHeight }) => (lineHeight ? lineHeight : '24px')};
  font-weight: ${themeGet('fontWeights.bold')};
  width: ${({ variation, width }) => {
    if (width) {
      return width;
    } else return variation === BUTTON_VARIATIONS.LARGE ? 65 : 56;
  }}px;
  color: ${({ color }) => (color ? color : themeGet('colors.deepLakeBlue.100'))};
`;
